import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/feature/Sidebar";
import Topbar from "@/components/feature/Topbar";
import { useAuth } from "@/hooks/useAuth";
import { useAppData } from "@/hooks/useDomains";
import { ensureLoaded } from "@/lib/store";
import { Navigate } from "react-router-dom";

const TITLES: Record<string, string> = {
  "/": "数据总览",
  "/domains": "域名跳转管理",
  "/analytics": "访问统计",
  "/settings": "系统设置",
};

export default function AdminLayout() {
  const { isAuthed, ready } = useAuth();
  const { ready: dataReady, loadError } = useAppData();
  const location = useLocation();

  useEffect(() => {
    if (isAuthed) void ensureLoaded();
  }, [isAuthed]);

  if (!ready) {
    return <div className="min-h-screen bg-background-50" />;
  }

  if (!isAuthed) {
    return <Navigate to="/login" replace />;
  }

  if (!dataReady) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-50 text-sm text-foreground-600">
        正在读取跳转规则…
      </div>
    );
  }

  if (loadError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background-50 px-6 text-sm text-foreground-700">
        {loadError}
      </div>
    );
  }

  const title = TITLES[location.pathname] ?? "数据总览";

  return (
    <div className="flex min-h-screen w-full bg-background-50">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar title={title} />
        <main className="flex-1 px-4 py-6 md:px-8 md:py-8">
          <Outlet />
        </main>
        <footer className="border-t border-background-200 px-4 py-4 md:px-8">
          <p className="text-xs text-foreground-500">© 2026 域名中转站后台 · 规则保存在运行这台服务的电脑上</p>
        </footer>
      </div>
    </div>
  );
}